import React from 'react';
import './PetAnimations.css';

export default function SnifferSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#6B8E50';
  const lightColor = color ? lighten(color) : '#8BB070';
  const darkColor = color ? darken(color) : '#4B6E30';
  const mossColor = '#4A7A38';
  const noseColor = '#8B6B4B';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body (large and round) */}
      <ellipse cx="60" cy="68" rx="34" ry="26" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="74" rx="22" ry="16" fill={lightColor} />
      {/* Moss patches on back */}
      <ellipse cx="50" cy="52" rx="8" ry="4" fill={mossColor} />
      <ellipse cx="68" cy="50" rx="6" ry="3" fill={mossColor} />
      <ellipse cx="58" cy="48" rx="5" ry="3" fill={mossColor} opacity="0.7" />
      {/* Plant sprouts on back */}
      <path d="M48 48L46 38L50 42Z" fill="#5AA040" />
      <path d="M48 48L44 40" stroke="#5AA040" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="43" cy="38" rx="3" ry="2" fill="#6BC050" />
      <path d="M66 46L68 36L64 40Z" fill="#5AA040" />
      <path d="M66 46L70 38" stroke="#5AA040" strokeWidth="1.5" strokeLinecap="round" />
      <ellipse cx="71" cy="36" rx="2.5" ry="2" fill="#6BC050" />
      {/* Small flower */}
      <circle cx="56" cy="42" r="2" fill="#E8A0C0" />
      <circle cx="56" cy="42" r="1" fill="#F0C840" />
      {/* Legs */}
      <rect x="36" y="86" width="12" height="14" rx="5" fill={bodyColor} />
      <rect x="72" y="86" width="12" height="14" rx="5" fill={bodyColor} />
      {/* Paws */}
      <ellipse cx="42" cy="100" rx="7" ry="3" fill={darkColor} />
      <ellipse cx="78" cy="100" rx="7" ry="3" fill={darkColor} />
      {/* Head */}
      <ellipse cx="38" cy="60" rx="18" ry="16" fill={bodyColor} />
      {/* Droopy nose */}
      <path d="M24 62C22 66 20 72 22 76C24 80 28 78 30 74C32 70 30 64 28 60" fill={noseColor} />
      <ellipse cx="23" cy="76" rx="4" ry="3" fill={darkColor} />
      {/* Nostrils */}
      <circle cx="21" cy="76" r="1.5" fill="#3A4A2A" />
      <circle cx="25" cy="76" r="1.5" fill="#3A4A2A" />
      {/* Eyes (gentle) */}
      <circle cx="34" cy="54" r="4" fill="white" />
      <circle cx="44" cy="54" r="4" fill="white" />
      <circle cx="35" cy="55" r="2.5" fill="#5A4020" />
      <circle cx="45" cy="55" r="2.5" fill="#5A4020" />
      <circle cx="35.5" cy="53.5" r="1" fill="white" />
      <circle cx="45.5" cy="53.5" r="1" fill="white" />
      {/* Gentle eyebrows */}
      <path d="M30 50C32 49 36 49 38 50" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M40 50C42 49 46 49 48 50" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Mouth */}
      <path d="M28 68C30 70 34 70 36 68" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
